module.exports = __webpack_public_path__ + "img/logo3.c69d85ce.jpeg";